import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { SelectItem } from 'primeng/api';
import { ListaItem } from '../../_models/lista-item';
import { DescripcionErrorIntegracion } from '../../_models/descripcion-error-integracion';
import { DescripcionErrorIntegracionService } from '../../_services/descripcion-error-integracion.service';

@Component( {
  selector: 'app-banco-error-integracion-listado',
  templateUrl: 'banco-error-integracion-listado.component.html'
} )

export class BancoErrorIntegracionListadoComponent implements OnInit {

  carInformacionInicial = true;
  bancoErrores: DescripcionErrorIntegracion[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  formulario: FormGroup;
  filtrando = false;
  lisIntegraciones: SelectItem[] = [];
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private serBancoError: DescripcionErrorIntegracionService,
               private navServicio: NavService,
               private router: Router,
               private serListas: ListaService,
               private autServicio: AutenticacionService,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/banco-error-integracion' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'integracion', header: this.navServicio.buscarMensaje( 'BANCOERROR.LBL_INTEGRACION' ), sort: true },
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'BANCOERROR.LBL_CODIGO' ), sort: true },
      { field: 'descripcionUsuario', header: this.navServicio.buscarMensaje( 'BANCOERROR.LBL_DESUSUARIO' ), sort: true },
      { field: 'descripcionTecnica', header: this.navServicio.buscarMensaje( 'BANCOERROR.LBL_DESTECNICA' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'banco-error-integracion.component' );

    forkJoin( this.serBancoError.listado(),
      this.serListas.getMasterDetails( 'ListasIntegraciones' ) ).subscribe( ( [ bancoError, integraciones ] ) => {
      this.bancoErrores = bancoError;
      integraciones.map( ( k: ListaItem ) => {
        this.lisIntegraciones.push( { label: k.nombre, value: k.nombre } );
      } );
      this.cargarFormulario();
      this.carTabla = false;
      this.carInformacionInicial = false;
      //this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      textoBuscar: [ null ],
      integracion: [ null ],
    } );
  }

  limpiarFiltros() {
    this.cargarFormulario();
    this.busqueda = null;
    this.tabla.reset();
    this.setBusqueda()
  }

  buscar() {
    this.filtrando = true;
    this.carTabla = true;
    if ( this.formulario.valid ) {
      const formulario = this.formulario.value;
      if ( formulario && formulario.integracion ) {
        this.tabla.filter( formulario.integracion, 'integracion', 'contains' );
      }
      if ( formulario && formulario.textoBuscar ) {
        this.tabla.filterGlobal( formulario.textoBuscar, 'contains' );
      }
      this.filtrando = false;
      this.carTabla = false;
    }

  }

  get f() {
    return this.formulario.controls;
  }

  crear() {
    this.router.navigate( [ 'apl/banco-error-integracion/agregar' ] );
  }

  editar( control: DescripcionErrorIntegracion ) {
    this.router.navigate( [ 'apl/banco-error-integracion/actualizar/' + control.idDescripcionErrorIntegracion ] )
  }

  visualizar( control: DescripcionErrorIntegracion ) {
    this.router.navigate( [ 'apl/banco-error-integracion/detalle/' + control.idDescripcionErrorIntegracion ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'banco-error-integracion.component', this.busqueda );
  }
}
